import { useParams } from 'react-router-dom';
import { useGetModuleSpecsQuery } from '../../../../../api/queries/getModuleSpecs';
import { ModuleType } from '../../../../../api/types';
import LoadingElement from '../../../../../components/LoadingElement';
import NotFoundResult from '../../../../../components/results/NotFoundResult';
import UpdateCtsSettingInnerPage from './UpdateCtsSettingInnerPage';

const UpdateCtsSettingPage = () => {
    const { moduleId, settingId } = useParams<{ moduleId: string; settingId: string }>();

    const { data, loading } = useGetModuleSpecsQuery({
        fetchPolicy: 'cache-first',
        variables: { moduleId },
    });

    if (!data && !loading) {
        return <NotFoundResult />;
    }

    if (loading) {
        return <LoadingElement />;
    }

    const { module } = data;

    if (module.__typename !== ModuleType.CtsModule) {
        return <NotFoundResult />;
    }

    const ctsSetting = module.ctsSettings.find(item => item.id === settingId);

    if (!ctsSetting) {
        return <NotFoundResult />;
    }

    return <UpdateCtsSettingInnerPage module={module} setting={ctsSetting} />;
};

export default UpdateCtsSettingPage;
